export const exportHeaders = [
    { 
        label: "Target Account", 
        key: "target_account" 
    },
    { 
        label: "Target Type", 
        key: "target_type" 
    },    
    { 
        label: "Status", 
        key: "is_active" 
    }
    ]